import { InjectionKey, Ref } from 'vue'
import { IUnauthenticatedRealmSettings } from '@src/types/realmSettings.types'

export const realmSettingsKey = Symbol('realmSettings') as InjectionKey<Ref<IUnauthenticatedRealmSettings>>
